export const NotFound = () => {
  return (
    <div className="NotFound">
      Page not found!
    </div>
  );
};

export default NotFound;

